import { useFacetData } from '~/context/srp/FacetDataContext';
import ColorSwatches from './ColorSwatches';
import FilterDrawer from '../FilterDrawer';
import useExpand from '../useExpand';
import type WithClassName from '../WithClassName';

type OwnProps = {
  facetKey: 'interiorColors' | 'colors';
};

export default function ColorFacet({
  className,
  facetKey
}: WithClassName & OwnProps) {
  const [show, setShow] = useExpand(false);
  const facetData = useFacetData();

  return (
    <FilterDrawer
      className={className}
      dataQa={`facet-colors-${facetKey}`}
      facetContent={facetData[facetKey]?.buckets ?? []}
      facetName={facetKey === 'colors' ? 'exterior colors' : 'interior colors'}
      show={show}
      onToggle={() => {
        setShow(!show);
      }}
    >
      <ColorSwatches filterKey={facetKey} />
    </FilterDrawer>
  );
}
